export interface RuleItemDirectiveModel {
	[ruleId: string]: RuleItemDirectiveDataModel;
}

export class RuleItemDirectiveDataModel {
	id: string; // roomID + RuleViolationArrayIndex,
	isCollapsed: boolean;
	path: string; // roomPath

	constructor() {
		this.id = '';
		this.isCollapsed = true;
		this.path = '';
	}
}